export default __webpack_public_path__ + "static/media/anitta.9a76a5b7.jpg";